/* import __COLOCATED_TEMPLATE__ from './related-conversations-list.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */

import templateOnlyComponent from '@ember/component/template-only';
import type { ConversationExploreConversation } from 'embercom/components/reporting/automation/ai-insights/conversation-panel';

interface Signature {
  Args: {
    sampleConversations: ConversationExploreConversation[];
    onConversationClicked: (conversation: ConversationExploreConversation) => void;
    isLoading: boolean;
  };
}

const RelatedConversationsList = templateOnlyComponent<Signature>();
export default RelatedConversationsList;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::OptimizeSuggestions::Suggestions::RelatedConversationsList': typeof RelatedConversationsList;
    'reporting/automation/ai-insights/optimize-suggestions/suggestions/related-conversations-list': typeof RelatedConversationsList;
  }
}
